<dx-drop-down-box
    #dropDownBox
    fieldTemplate="textfieldTemplate"
    contentTemplate="contentTemplate"
    [dropDownButtonTemplate]="buttonTemplate"
    [disabled]="disabled"
    [readOnly]="readOnly"
    [valueExpr]="valueExpr"
    [displayExpr]="displayExpr"
    [dropDownOptions]="dropDownOptions"
    [elementAttr]="elementAttr"
    [dataSource]="gridSource"
    [openOnFieldClick]="false"
    [value]="boxValue"
    (onFocusIn)="onDropdownFocusIn($event)"
    (onOpened)="onDropdownOpen($event)"
    (onClosed)="onDropdownClose($event)"
>
    <dx-validator *ngIf="isRequired" [validationGroup]="validationGroup">
        <dxi-validation-rule
            type="custom"
            message="{{ name }} is required"
            [validationCallback]="customValidationCallback"
        ></dxi-validation-rule>
    </dx-validator>

    <div *dxTemplate="let data of 'textfieldTemplate'" class="dropdown-textfield">
        <dx-text-box
            #dropDownBoxTextBox
            width="100%"
            [showClearButton]="showClearButton || isEditEnabled"
            [readOnly]="readOnly"
            [value]="textInputVal"
            [placeholder]="placeholder"
            [inputAttr]="dropDownInputAttr"
            (onFocusOut)="onTextFocusOut($event)"
            (onKeyDown)="onTextKeyDown($event)"
            (onKeyUp)="onTextKeyUp($event)"
            (onValueChanged)="onValueChanged($event)"
        >
            <dxi-button
                name="status"
                location="after"
                [options]="{
                    type: 'normal',
                    stylingMode: 'text',
                    template: 'community-status-template',
                    visible: navigateToCommunity && selectedItem,
                    onClick: onNavigateToCommunity
                }"
            >
                <div *dxTemplate="let data of 'community-status-template'">
                    <i
                        *ngIf="selectedItem && selectedItem.status === 'InTransition'"
                        class="cc-community-intransition"
                        aria-hidden="true"
                        [title]="getStatus(selectedItem, 'InTransition')"
                        [ngClass]="iconTransition"
                    ></i>
                    <i
                        *ngIf="selectedItem && selectedItem.status === 'Terminated'"
                        class="cc-community-terminated"
                        aria-hidden="true"
                        [title]="getStatus(selectedItem, 'Terminated')"
                        [ngClass]="iconTerminate"
                    ></i>
                    <i
                        *ngIf="!!selectedItem && !!selectedItem.terminatingDate && selectedItem.status !== 'Terminated'"
                        class="cc-community-terminating"
                        aria-hidden="true"
                        [title]="getStatus(selectedItem, 'Terminating')"
                        [ngClass]="iconExclamatory"
                    ></i>
                </div>
            </dxi-button>
            <dxi-button
                name="navigate"
                location="after"
                [options]="{
                    type: 'default',
                    stylingMode: 'text',
                    icon: 'fas fa-map-marker-alt',
                    hint: 'Navigate To Community',
                    visible: navigateToCommunity && selectedItem,
                    onClick: onNavigateToCommunity
                }"
            ></dxi-button>
            <dxi-button name="clear" location="after"></dxi-button>
        </dx-text-box>
    </div>

    <div *dxTemplate="let data of 'dropDownButton'">
        <div class="dx-dropdowneditor-icon"></div>
    </div>

    <div *dxTemplate="let data of 'dropDownArrayButton'">
        <ng-container *ngIf="!!isEditEnabled">
            <div class="select-button-container">
                <div class="select-button-content">
                    <ng-container *ngFor="let button of inlineButtonTemplate">
                        <dx-button
                            [text]="button.text"
                            [icon]="button.icon"
                            [class]="button.class"
                            [type]="button.type"
                            [tabIndex]="-1"
                            (onClick)="onTemplateButtonClick($event, button)"
                        ></dx-button>
                    </ng-container>
                </div>
                <div class="select-button-content">
                    <dx-button class="dx-dropdowneditor-icon cc-dummy-button" type="normal" [tabIndex]="-1"></dx-button>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!isEditEnabled" class="dx-dropdowneditor-icon"></div>
    </div>

    <div *dxTemplate="let data of 'contentTemplate'" class="dropdown-content-container">
        <dx-data-grid
            #dataGrid
            height="100%"
            class="data-grid"
            [dataSource]="gridSource"
            [hoverStateEnabled]="true"
            [selection]="{ mode: 'single' }"
            [filterRow]="{ visible: false }"
            [scrolling]="{ mode: 'virtual' }"
            [keyExpr]="valueExpr"
            [selectedRowKeys]="boxValue"
            [columnAutoWidth]="true"
            [columns]="columnDef"
            [focusStateEnabled]="true"
            [focusedRowEnabled]="true"
            [focusedRowIndex]="focusedRowIndex"
            [autoNavigateToFocusedRow]="true"
            [wordWrapEnabled]="wordWrapEnabled"
            (onSelectionChanged)="onSelectionChanged($event)"
            (onRowClick)="onRowClick($event)"
        >
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
            <dxo-search-panel [visible]="false" [highlightSearchText]="false" [text]="searchText"></dxo-search-panel>

            <div *dxTemplate="let data of 'trueValueCellTemplate'">
                <div *ngIf="data.value === true">
                    <i class="fa-lg cc-icon-check" [ngClass]="iconCheck"></i>
                </div>
            </div>

            <div *dxTemplate="let data of 'falseValueCellTemplate'">
                <div *ngIf="data.value === false">
                    <i class="fa-lg cc-icon-cross" [ngClass]="iconCross"></i>
                </div>
            </div>

            <div *dxTemplate="let data of 'booleanValueCellTemplate'">
                <div *ngIf="data.value === true; then checkBlock; else crossBlock"></div>
                <ng-template #checkBlock><i class="fa-lg cc-icon-check" [ngClass]="iconCheck"></i></ng-template>
                <ng-template *ngIf="data.value === false" #crossBlock>
                    <i class="fa-lg cc-icon-cross" [ngClass]="iconCross"></i>
                </ng-template>
            </div>

            <div *dxTemplate="let d of 'dimensionTemplate'">
                <strong>{{ d.data.dimensionTitle }}:</strong>
                {{ d.data.dimensionOptionTitle }}
            </div>

            <div *dxTemplate="let data of 'multiDimensionsTemplate'">
                <div *ngFor="let dim of data.data.glDimensions">
                    <strong>{{ dim.dimensionTitle }}:</strong>
                    {{ dim.dimensionOptionTitle }}
                </div>
            </div>

            <div *dxTemplate="let data of 'isDefaultTemplate'">
                <i *ngIf="data.data.isDefault" class="fa-lg cc-check-icon" [ngClass]="iconCheck"></i>
                <i *ngIf="!data.data.isDefault" class="fa-lg cc-cross-icon" [ngClass]="iconCross"></i>
            </div>

            <div *dxTemplate="let row of 'communityCellTemplate'" class="community-cell-template">
                <span>{{ row.value }}</span>
            </div>

            <div *dxTemplate="let row of 'statusCellTempalte'" class="status-cell-template">
                <i
                    *ngIf="row.value === 'InProduction'"
                    class="cc-community-production cc-1-5x"
                    [ngClass]="iconProduction"
                    aria-hidden="true"
                    [title]="getStatus(row.data, 'In Production')"
                ></i>
                <i
                    *ngIf="row.value === 'InTransition'"
                    class="cc-community-intransition cc-1-25x"
                    [ngClass]="iconTransition"
                    aria-hidden="true"
                    [title]="getStatus(row.data, 'In Transition')"
                ></i>
                <i
                    *ngIf="row.value === 'Terminated'"
                    class="cc-community-terminated cc-1-25x"
                    [ngClass]="iconTerminate"
                    aria-hidden="true"
                    [title]="getStatus(row.data, 'Terminated')"
                ></i>
                <i
                    *ngIf="!!row.data.terminatingDate && row.value !== 'Terminated'"
                    class="cc-community-terminating cc-1-25x"
                    [ngClass]="iconExclamatory"
                    aria-hidden="true"
                    [title]="getStatus(row.data, 'Terminating')"
                ></i>
            </div>
        </dx-data-grid>
    </div>
</dx-drop-down-box>
